<template>
  <div class="task_detail">
    <p class="detail_title">
      <span class="title">{{taskDetail.subject}}</span>
      <span>作业详情</span>
    </p>
    <p class="notice_publish_info">
      <span class="writer notice_info_item">{{taskDetail.writer}}</span>
      <span class="time notice_info_item">{{taskDetail.issueDate}}</span>
    </p>
    <p class="notice_content">{{taskDetail.contentInfoList[0].content}}</p>
    <viewer class="" :images="taskDetail.images">
      <img class="task_detail_img" v-for="item in taskDetail.images" :src="item.uri" alt="">
    </viewer>
    <div class="section_wrapper">
      <audio v-for="item in taskDetail.voices" :src="item.uri" controls="controls"></audio>
    </div>
    <p class="table_caption">
      <span>作业答案</span>
    </p>
    <viewer :images="taskDetail.answerImages">
      <img class="task_detail_img" v-for="item in taskDetail.answerImages" :src="item.uri" alt="">
    </viewer>
    <p class="table_caption">
      <span>自动提醒时间</span>
      <span class="important_time">{{taskDetail.promptTime}}</span>
      <span class="table_caption label_title">完成参考时间：</span>
      <span class="important_time">{{taskDetail.cost}}</span>
      <span class="table_caption label_title">{{taskDetail.taskPrizesInfo ? '表扬对象：' : '未发布表扬'}}</span>
      <span class="important_time" v-if="taskDetail.taskPrizesInfo">{{taskDetail.taskPrizesInfo.prizeNumber}}人</span>
    </p>
    <Table border stripe size="large" :columns="tableHeader" :data="taskDetail.assignmentReceiptInfoList">
      <template slot-scope="{row}" slot="studentName">
        <div class="jump_color" @click="toStudentDetail(row.studentName)">{{row.studentName}}</div>
      </template>
      <template slot-scope="{row}" slot="taskReceiptId">
        <div >{{row.taskReceiptId ? '已提交' : '未提交'}}</div>
      </template>
      <template slot-scope="{row}" slot="isCheck">
        <span>{{row.isCheck ? '已查看' : '未查看'}}</span>
      </template>
      <template slot-scope="{row}" slot="action">
        <div class="jump_color" @click="getStudentTaskDetail(row.studentName,row.taskReceiptId)">{{row.taskReceiptId?'查看':''}}</div>
      </template>
    </Table>
    <Modal class="top_search_modal" v-model="studentTaskDetailStatus" :title="studentName+ taskDetail.subject + '作业'">
      <div class="top_search_wrapper">
        <p class="notice_publish_info">
          <span class="writer notice_info_item">{{studentTaskDetail.uploader}}</span>
          <span class="time_finish notice_info_item">{{studentTaskDetail.finishDate}}</span>
        </p>
        <p class="notice_content">{{studentTaskDetail.message}}</p>
        <viewer class="" :images="studentTaskDetail.assignmentReceiptImageInfoList">
          <img class="task_detail_img" v-for="item in studentTaskDetail.assignmentReceiptImageInfoList" :src="item.uri" alt="">
        </viewer>
        <div class="section_wrapper">
          <audio v-for="item in studentTaskDetail.assignmentReceiptVoiceInfoList" :src="item.uri" controls="controls"></audio>
        </div>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="studentTaskDetailStatus = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import paging from '../templates/Paging.vue';
  import {_getTaskDetail,_getStudentTaskDetail} from '../api/api';
  import globalData from '../common/Global';
  import {dealImgUrl,YearMonthDate} from '../common/common';
  export default {
    components: {paging},
    data() {
      return {
        id: '',
        taskDetail: {},
        studentTaskDetailStatus:false,//学生作业详情弹框
        studentName: '',//学生姓名
        studentTaskDetail: {},
        tableHeader:[
          {
            type:'index',
            width:60,
            align: 'center'
          },
          {
            title: '姓名',
            key: 'studentName',
            slot: 'studentName'
          },
          {
            title: '提交状态',
            key: 'taskReceiptId',
            slot: 'taskReceiptId'
          },{
            title: '查看状态',
            key: 'isCheck',
            slot: 'isCheck'
          },
          {
            title: '提交时间',
            key: 'submitTime',
            width: 150,
            sortable:true
          },
          {
            title: '提交人',
            key: 'uploader'
          },
          {
            title: '操作',
            key: 'action',
            slot: 'action'
          }
        ]
      }
    },
    methods: {
//      老师作业详情
      getTaskDetail() {
        const self = this;
        _getTaskDetail(self.id).then(res => {
          if(res.code === 0) {
            self.taskDetail = res.data;
            self.taskDetail.issueDate = YearMonthDate(self.taskDetail.issueDate);
            self.taskDetail.images.length > 0 && self.taskDetail.images.forEach(item => {
              item.uri = dealImgUrl(item.uri);
            });
            self.taskDetail.answerImages.length > 0 &&self.taskDetail.answerImages.forEach(item => {
              item.uri = dealImgUrl(item.uri);
            });
            self.taskDetail.voices.length > 0 &&self.taskDetail.voices.forEach(item => {
              item.uri = dealImgUrl(item.uri);
            })
          }
        })
      },
//      查看学生作业详情
      getStudentTaskDetail (studentName,id) {
        const self = this;
        self.studentName = studentName;
        if(id) {
          self.studentTaskDetailStatus = true;
          _getStudentTaskDetail(self.id, id).then(res => {
            if(res.code === 0) {
              self.studentTaskDetail = res.data;
              self.studentTaskDetail.finishDate = YearMonthDate(self.studentTaskDetail.finishDate);
              self.studentTaskDetail.assignmentReceiptImageInfoList.length > 0 &&self.studentTaskDetail.assignmentReceiptImageInfoList.forEach(item => {
                item.uri = dealImgUrl(item.uri);
              });
              self.studentTaskDetail.assignmentReceiptVoiceInfoList.length > 0 &&self.studentTaskDetail.assignmentReceiptVoiceInfoList.forEach(item => {
                item.uri = dealImgUrl(item.uri);
              });
            }
          })
        }

      },
//      跳转到学生列表
      toStudentDetail(studentName) {
        this.$router.push(`/students?name=${studentName}`)
      }
    },
    mounted() {
      this.getTaskDetail();
    },
    created() {
      this.id = this.$route.query.id;
    }
  }
</script>
<style>
  .notice_publish_info{
    line-height: 32px;
    font-size: 14px;
    color:#666;
    text-align: center;
  }
  .time_finish{
    margin-left: 20px;
  }
  .notice_content{
    line-height: 28px;
    font-size: 16px;
    color:#000;
  }
  .task_detail_img{
    height:100px;
    border-radius:6px;
    margin-right:8px;
  }
  .label_title{
    margin-left: 15px;
  }
  .important_time{
    font-size: 16px;
    color:#666;
  }
  .section_wrapper{
    margin-top: 15px;
  }
  .section_wrapper > audio{
    height: 30px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TaskDetail.vue